export default {
  methods: {
    getGroupsLists(item) {
      const arr = [];
      const chunkSize = 10;
      const groups = this.$utils.sortIgnoringCase(this.$utils.deepCopy(item.groups));

      for (let idx = 0; idx < groups.length; idx += chunkSize) {
        arr.push(groups.slice(idx, idx + chunkSize));
      }

      return arr;
    },
  },
};
